import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ColaboradorPerfilService extends BaseService {
  constructor() {
    super(`${ConfigApi.colaboradorPerfilURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.nome = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new ColaboradorPerfilService();
